// Single source of truth for the site's scroll-reveal tuning. Reveal and
// RevealGroup both read from here so a transition tweak only has to happen
// in one place.
export const REVEAL_EASE_OUT = [0.4, 0, 0.2, 1] as const;

// margin shrinks the viewport inward so reveals trigger a bit before/after
// the true edge instead of right at it. The "only reveal once" behavior is
// handled by useReveal's own hasRevealed state, not by useInView's `once`
// option, since useReveal needs to force a reveal for elements already
// scrolled past on mount (which `once` alone can't express).
export const REVEAL_VIEWPORT = { margin: "-100px 0px -60px 0px" } as const;

export const REVEAL_Y = 16;
export const REVEAL_DURATION = 0.6;

export const REVEAL_GROUP_ITEM_DURATION = 0.5;
export const REVEAL_GROUP_STAGGER_CHILDREN = 0.12;
export const REVEAL_GROUP_DELAY_CHILDREN = 0.05;
